module.exports = __webpack_public_path__ + "static/img/vod-bn-6.34ef6c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-6.jpg
// module id = hR4U
// module chunks = 1